<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-sort`]" width="1em" height="1em" v-bind="$attrs"><path d="M11.7773 1.60045C12.0103 1.49087 12.2859 1.52534 12.4844 1.68932L15.5459 4.21959C15.7439 4.38332 15.8297 4.64633 15.7666 4.89538C15.7034 5.14429 15.5029 5.33495 15.251 5.38463L12.7256 5.87975V13.7987C12.7255 14.1658 12.4277 14.4636 12.0605 14.4637C11.6933 14.4637 11.3956 14.1659 11.3955 13.7987V2.20202C11.3955 1.9445 11.5444 1.71017 11.7773 1.60045ZM9.25781 11.8026C9.56078 11.8645 9.78883 12.1328 9.78906 12.454C9.78906 12.7753 9.56085 13.0433 9.25781 13.1053L9.12402 13.119H1.66504C1.29777 13.119 1 12.8212 1 12.454C1.00026 12.0869 1.29793 11.7889 1.66504 11.7889H9.12402L9.25781 11.8026ZM9.25781 7.85241C9.56084 7.91434 9.78895 8.18247 9.78906 8.50377C9.78906 8.82516 9.56088 9.09316 9.25781 9.15514L9.12402 9.16881H1.66504C1.29777 9.16881 1 8.87104 1 8.50377C1.00013 8.13662 1.29785 7.83873 1.66504 7.83873H9.12402L9.25781 7.85241ZM9.25781 3.90221C9.56085 3.96417 9.789 4.23224 9.78906 4.55358C9.78901 4.87493 9.56087 5.14299 9.25781 5.20495L9.12402 5.21862H1.66504C1.29781 5.21862 1.00007 4.92079 1 4.55358C1.00007 4.18637 1.29781 3.88854 1.66504 3.88854H9.12402L9.25781 3.90221Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineSort',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
